import { useGetIdentity } from "@refinedev/core";
import { Navigate, Outlet } from "react-router";
import type { UserInfo } from "../types/auth";
import { LoadingSpinner } from "./common/LoadingSpinner";

/** user_type values that grant admin access */
const ADMIN_USER_TYPES = [1, 2];

/**
 * Route guard that restricts access to admin users only (user_type 1 or 2).
 * Redirects non-admin users to the home page.
 */
export const AdminRoute = () => {
  const { data: identity, isLoading } = useGetIdentity<UserInfo>();

  if (isLoading) {
    return <LoadingSpinner fullScreen tip="Checking permissions..." />;
  }

  const userType = identity?.app_user?.user_type;
  const isAdmin = userType !== undefined && ADMIN_USER_TYPES.includes(userType);

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};
